import { render, staticRenderFns } from "./calEventDialog.vue?vue&type=template&id=0af1a266"
import script from "./calEventDialog.vue?vue&type=script&lang=js"
export * from "./calEventDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports